module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABHklEQVQ4T7XTvUvVURgH8M9XDXESwt4Gh9Yg0LmtRdoaGsX+B6OmIIJwMHQQR6cSXCTcxD/AWZsaHRryBYQmDaJHfvFLbnhvSJd7xsPzfM6X55wTfa702W+wQFW9aBNuYAm/sJjk85/kXRNUVbO/iuJ3yiGs4DEmkrztCVTVMNZwkuRVU1hVi7iFT3iYZKErUFU38BFfOk9pkTd4gOdJzq8AVTWCTewmed/tdqrqJR7hWZKfTc3lDKpqHE8xmeRdD+A1vmIryfe/gDbmHXxIMlNV9/CkhbaTfKuqHcwlOeo1g05gtonaFm4mWf8f4G4LHF4XGMM+9nAfyy0wjwNMYyrJ2b/ewU3cxo8kTVPzDhpsFMdJTjsHPNi/cJ2fegFMMXER0O3kCQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/menuicon/icon_home.png
// module id = N0R7
// module chunks = 3